import { getProjectByUUID, getProjects } from "../../api/ApiProject";

class ProjectService {
  // @js-check
  /// <reference path="./types/index.js" />

  /** @type {LayerGroup} */
  static async get_project_by_uuid(project_uuid) {
    return await getProjectByUUID(project_uuid);
  }

  static async get_projects() {
    return await getProjects();
  }
}
export default ProjectService;
